import React from "react";
import moment from "moment";
import greetingTime from "greeting-time";
import { useSelector } from "react-redux";
import { useThemeColor } from "../../Sidebar/SideBarApi";
import Abstract from "../../../assets/Images/Abstract.png";

const Greetings = () => {
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const themeColor = useThemeColor();

  return (
    <div className="relative bg-base-color rounded-xl p-12 overflow-hidden">
      <img src={Abstract} alt="" className=" absolute right-0 top-0 h-full max-w-[40%] object-contain pointer-events-none " />
      <h1 className="mb-0 text-white font-Nata-Sans font-[400] pt-2 capitalize text-[26px]  md:text-[36px]  sm:text-[34px] ">
        {greetingTime(new Date())},<br className="block sm:hidden" />
        <span className="text-white font-bold capitalize text-[26px] md:text-[36px] sm:text-[34px] whitespace-nowrap">
          {UserDetails?.first_name} {UserDetails?.last_name}
        </span>
      </h1>
      <div className="w-full  flex flex-row items-center gap-1">
        <h4 className="ml-1 mb-0 text-white font-semibold pt-2   text-[19px] md:text-[22px]  sm:text-[25px]  base-font-pop">
          {moment().format("dddd , DD MMMM YYYY")}
        </h4>
      </div>
    </div>
  );
};

export default Greetings;
